module.exports = __webpack_public_path__ + "static/media/20-11.3f70cebb.mp3";